export abstract class AssRefUsisEvent {}

export class AssRefUsisLoad extends AssRefUsisEvent {}
